export const Spacing = {
  desktop: {
    xs: "0.5vw",
    sm: "1vw",
    md: "16px",
    lg: "24px",
    xl: "48px",
  },
  videowall: {
    xxxs: "0.105vw", //In Cascais (7680x2169) = 8.0px
    xxs: "0.209vw", //In Cascais (7680x2169) = 16.0px
    xs: "0.313vw",//In Cascais (7680x2169) = 24.0px
    sm: "0.417vw",//In Cascais (7680x2169) = 32.0px
    md: "0.547vw",//In Cascais (7680x2169) = 42.0px
    lg: "0.678vw",//In Cascais (7680x2169) = 52.0px
    xl: "0.756vw",//In Cascais (7680x2169) = 58.0px
    xxl: "0.834vw",//In Cascais (7680x2169) = 64.0px,
    xxxl: "0.939vw"//In Cascais (7680x2169) = 72.1px,
  }
}